export type AdvancedTopicKnowledgeSearchCriteria = { id?: string; secondaryTopicId?: string };

export type TopicKnowledgePackage = { data: string[]; hasNextPage: boolean; isFetching: boolean };

export enum DestinationTypes {
  CUSTOM = "Custom Maps",
  COLLECTION = "Collection",
  ALL = "All topics",
}
